var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOffers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "offers_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  mask: "url(#offers_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.16 21.259 20.439 6.538a2.81 2.81 0 0 0-1.994-.82h-9.9a2.837 2.837 0 0 0-2.827 2.828v9.899c0 .777.31 1.485.834 2.008l14.72 14.72s.925-.907 1.995-2.007l9.899-9.9 1.994-2.007Zm-13.887 9.927L8.546 18.445v-9.9h9.899v-.013l12.727 12.727-9.9 9.927Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.081 14.202a2.121 2.121 0 1 0 0-4.242 2.121 2.121 0 0 0 0 4.242Z"
}))));
export default SvgOffers;